import SettingsStep from './SettingsStep';

export default SettingsStep;
